<div class="container">
  <div class="card-header">
    <div class="title-section">
      <h5 class="header-title">{{ model && model.data ? 'Editar Contabilidad' : 'Agregar Contabilidad' }}</h5>
    </div>
    <div class="button-section">
      <button type="submit" class="btn-success" mat-flat-button (click)="continue()" style="margin-right: 20px" [disabled]="form.invalid" appPermissionControl="P130B0001">
        <mat-icon aria-hidden="false" class="icon-btn">save</mat-icon>
        {{ model && model.data ? 'Actualizar' : 'Guardar' }}
      </button>
      <button mat-stroked-button class="btn-cancel" (click)="close()" appPermissionControl="P130B0002">
        <mat-icon aria-hidden="false" class="icon-btn">close</mat-icon>
        Cerrar
      </button>
    </div>
  </div>

  <div style="margin-top: 50px; padding: 10px">
    <form [formGroup]="form" appPermissionControl="P130F0001">
      <div class="form-row">
        <!-- Origen -->
        <div class="form-field">
          <select formControlName="let_origen" class="form-control" appPermissionControl="P130K0001">
            <option value>-- Seleccione Origen --</option>
            <option *ngFor="let option of origenList" [value]="option.sValor">{{ option.sValor }} | {{ option.sOpcion }}</option>
          </select>
          <label>Origen</label>
        </div>

        <!-- Tipo Movimiento -->
        <div class="form-field">
          <select formControlName="let_tipomov" class="form-control" appPermissionControl="P130K0002">
            <option value>-- Seleccione Tipo --</option>
            <option *ngFor="let tipo of tipoMovList" [(value)]="tipo.sValor">{{ tipo.sValor }} | {{ tipo.sOpcion }}</option>
          </select>
          <label>Tipo</label>
        </div>

        <!-- Concepto -->
        <div class="form-field">
          <select formControlName="iConcepto" class="form-control" appPermissionControl="P130K0003">
            <option value>-- Seleccione Concepto --</option>
            <option *ngFor="let concepto of conceptos" [(value)]="concepto.concepto">{{ concepto.concepto }} | {{ concepto.descripcion }}</option>
          </select>
          <label>Concepto</label>
        </div>

        <!-- Sub Concepto -->
        <div class="form-field">
          <select formControlName="iSubConcepto" class="form-control" appPermissionControl="P130K0004">
            <option value>-- Seleccione Sub Concepto --</option>
            <option *ngFor="let item of conceptos" [(value)]="item.concepto">{{ item.concepto }} | {{ item.descripcion }}</option>
          </select>
          <label>Sub Concepto</label>
        </div>
      </div>

      <h3>
        <span>Créditos con Plazo igual o inferior a 12 meses</span>
      </h3>

      <div class="form-row">
        <!-- Cuenta Debito -->
        <div class="form-field">
          <select formControlName="sCuenta" class="form-control" appPermissionControl="P130K0005">
            <option value>-- Seleccione Cuenta --</option>
            <option *ngFor="let cata of catalogo" [(value)]="cata.sCuenta">{{ cata.sCuenta }} | {{ cata.sDescripcion }}</option>
          </select>
          <label>Cuenta Debito</label>
        </div>

        <!-- Cuenta Credito -->
        <div class="form-field">
          <select formControlName="sContra" class="form-control" appPermissionControl="P130K0006">
            <option value>-- Seleccione Cuenta --</option>
            <option *ngFor="let cta of catalogo" [(value)]="cta.sCuenta">{{ cta.sCuenta }} | {{ cta.sDescripcion }}</option>
          </select>
          <label>Cuenta Credito</label>
        </div>
      </div>

      <h3>
        <span>Créditos con Plazo mayor a 12 meses</span>
      </h3>

      <div class="form-row">
        <!-- Cuenta Debito -->
        <div class="form-field">
          <select formControlName="sCuenta12" class="form-control" appPermissionControl="P130K0007">
            <option value>-- Seleccione Cuenta --</option>
            <option *ngFor="let cte of catalogo" [(value)]="cte.sCuenta">{{ cte.sCuenta }} | {{ cte.sDescripcion }}</option>
          </select>
          <label>Cuenta Debito</label>
        </div>

        <!-- Cuenta Credito -->
        <div class="form-field">
          <select formControlName="sContra12" class="form-control" appPermissionControl="P130K0008">
            <option value>-- Seleccione Cuenta --</option>
            <option *ngFor="let ctr of catalogo" [(value)]="ctr.sCuenta">{{ ctr.sCuenta }} | {{ ctr.sDescripcion }}</option>
          </select>
          <label>Cuenta Credito</label>
        </div>
      </div>
    </form>
  </div>
</div>
